import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const SET_USER_AUTH = 'SET_USER_AUTH';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const SET_MFA_AUTH_ENABLED = 'SET_MFA_AUTH_ENABLED';

export type TSetUserAuthParams = {
  slug: string;
  params: Object;
};

// Action Creator
const UserAuthActionCreator = {
  setUserAuth(params: any): TAction<TSetUserAuthParams> {
    return {
      type: SET_USER_AUTH,
      payload: params
    };
  },
  setMFAAuth(isMfaEnabled: boolean): TAction<boolean> {
    return {
      type: SET_MFA_AUTH_ENABLED,
      payload: isMfaEnabled
    };
  },
  showLoadingSpinner(show: boolean): TAction<boolean> {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default UserAuthActionCreator;
